import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const previewPaperSx = {
  width: "95vw",
  maxWidth: "95vw",
  height: "90vh",
  maxHeight: "90vh",
};

const PromoStoreReportPreviewDialog = ({ open, onClose, title, children, actions, paperSx = null, contentSx = null, titleSx = null }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    fullWidth
    PaperProps={{ sx: { ...previewPaperSx, ...(paperSx || {}) } }}
  >
    <DialogTitle sx={{ px: 3, pt: 2.5, pb: 1.5, ...(titleSx || {}) }}>{title}</DialogTitle>
    <DialogContent sx={{ px: 3, pb: 2, pt: 0, ...(contentSx || {}) }}>{children}</DialogContent>
    <DialogActions sx={{ flex: "0 0 auto", gap: 1, px: 3, py: 1.5, borderTop: "1px solid", borderColor: "divider", backgroundColor: "background.paper" }}>
      {actions}
    </DialogActions>
  </Dialog>
);

PromoStoreReportPreviewDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node.isRequired,
  paperSx: PropTypes.shape({}),
  contentSx: PropTypes.shape({}),
  titleSx: PropTypes.shape({}),
};

export default PromoStoreReportPreviewDialog;
